import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    FetchData, Helpers,

    defaultData,
    
    //------------- Forms
    Forms,
    
    globalStates

})=>{

    const {convertToFloat} = Helpers

    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const closeModal = () => {
        toggle()
    }

    const handleClickShowForm = (openingMode) => {
        const { setShowForm, setFormOpeningMode} = globalStates
        setFormOpeningMode(openingMode)
        setShowForm(true)
    }

    const handleClickHideForm = () => {

        const {setShowForm, setStepApplilication} = globalStates
        
        const {fetchAllVehicleSales:{executeFetchAllVehicleSales}} = FetchData

        const { FormRequestGlobal : {onResetForm}} = Forms

        onResetForm()
        executeFetchAllVehicleSales()

        setStepApplilication(0)
        setShowForm(false)
    }

    const handleClickReturnStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication-1)
    }

    const handleClickNextStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication+1) 
    }



    const handleClickCleanUpFiles = (event) => {
        const { FormRequestGlobal:{setFormState} } = Forms

        setFormState(prevState => ({
            ...prevState,
            fileRejections: [],
            acceptedFiles: []
        }))

    }


const handleChangeTypeCurrency = (event) => {

    //HOOKS
    const {FormDeposit} = Forms
    const {setFormState, formState} = FormDeposit
    const {clean_deposito_monto, deposito_tipo_cambio} = formState
    
    const { name, value } = event.target

    //Verificamos si tiene data
    const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;


    if (value === 'DOLAR') {
        setFormState(prevState => ({
            ...prevState,
            [ name ]: value,
            deposito_quetzales : numberFormatter.format(clean_deposito_monto*tipo_cambio),
            deposito_dolares : numberFormatter.format(clean_deposito_monto),
            clean_deposito_quetzales: (clean_deposito_monto*tipo_cambio),
            clean_deposito_dolares: clean_deposito_monto
        }))
    }else if (value === 'QUETZAL') {
        setFormState(prevState => ({
            ...prevState,
            [ name ]: value,
            deposito_quetzales : numberFormatter.format(clean_deposito_monto),
            deposito_dolares : numberFormatter.format(clean_deposito_monto/tipo_cambio),
            clean_deposito_quetzales: clean_deposito_monto,
            clean_deposito_dolares: (clean_deposito_monto/tipo_cambio)
        }))
    }
}


    const onSubmitFormApplies = async (e) => {
        e.preventDefault()
        handleClickNextStep()
    }

    const onSendLogs = async (e) => {

        
        const { FormRequestGlobal } = Forms
        const {formState, setFormState} = FormRequestGlobal

        const { fetchInfoObservations:{executeFetchAllObservations} } = FetchData


        const {getCurrentDate} = Helpers
        
        await marvarApi.post(`/vehicle/mgmt-sales/log-vehicle/${formState.idventa}`, {
            idusuario: user.uid,
            log_fecha: getCurrentDate(),
            log_observacion: formState.aprobacion_observaciones,
            log_departamento: "Administrador"
        })
        .then(({data}) => {
            alertMessage(data)
            if (data.title === 'OK') {
                setFormState((prevState) => ({
                    ...prevState,
                    aprobacion_observaciones: ''
                }))
                executeFetchAllObservations()
            }
        })

    }

    const onSubmitFormFiles = async (e) => {

        e.preventDefault()
      
        const { FormRequestGlobal:{formState, setFormState} } = Forms
        const {getCurrentDate} = Helpers


        const {fetchAllFiles:{executeFetchAllFiles}, fetchInfoSales:{executeFetchInfoSales}} = FetchData
        

        
        if(formState.acceptedFiles.length<=0){
            const messageCustom = {
                message: 'No se ha cargado nigun archivo',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)    
            return 
        }

        const _data = new FormData();

        _data.append('idventa', formState.idventa);
        _data.append('department', 'JURIDICO');
        _data.append('usuario_creo', user.username);
        _data.append('fecha_creo', getCurrentDate());


        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`attachmentt`, file);
        });

        if(formState.idventa>0){
            
            await marvarApi.post( `/vehicle/mgmt-sales/create-document`, _data )
                .then(async({ data }) => {
                    
                    alertMessage(data)

                    if (data.title === 'OK') {
                        
                        await marvarApi.put(`/vehicle/admin-sales/aprobacion-check-sale/${formState.idventa}`, {aprobacion_check: 'Venta Finalizada', aprobacion_usuario: user.username, aprobacion_fecha: getCurrentDate()})
                        .then(({ data }) => {
                            alertMessage(data)
                            executeFetchInfoSales()
                        })
                        .catch(error => {
                            console.log('API ERROR: ', error)
                        })

                        setFormState(prevState => ({
                            ...prevState,
                            acceptedFiles : [],
                            fileRejections : []
                        }))
                        executeFetchAllFiles()
                    }
                    })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
                    
        }
    }

    const handleClickDeleteDocument = (iddocumento) => {

        const { fetchAllFiles:{executeFetchAllFiles} } = FetchData

        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/vehicle/mgmt-sales/delete-document/${iddocumento}`)
                .then( ({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        executeFetchAllFiles()
                        }else{
                            
                        }
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }


    const handleClickShowModal = (_, title, compont, dataRequest, modalOpeningMode) => {
        const {setModalOpeningMode} = globalStates
        setModalOpeningMode(modalOpeningMode)
        openModal(_, title, compont, dataRequest)
    }

    const handleClickCloseModal = () => {
        
        //HOOKS
        const { FormDeposit, FormPreInvventory } = Forms
        const { onResetForm } = FormDeposit
        const onResetFormInvventory = FormPreInvventory.onResetForm
        onResetForm()
        onResetFormInvventory()
        closeModal()
    }

    const onSubmitFormDeposits = async (e) => {

        e.preventDefault()
    
        const { FormDeposit, FormRequestGlobal } = Forms
        const { formState, onResetForm } = FormDeposit
    
        const {fetchAllDeposits} = FetchData
        const {executeFetchAllDeposits} = fetchAllDeposits

        const {getCurrentDate} = Helpers

        const body = {
            aprobacion_check: formState.aprobacion_check,
            aprobacion_referencia_ach : formState.aprobacion_referencia_ach,
            aprobacion_observaciones : formState.aprobacion_observaciones,
            aprobacion_usuario: user.username,
            aprobacion_fecha: getCurrentDate()
        }

        await marvarApi.put( `/vehicle/admin-sales/aprobacion-check-deposit/${formState.iddeposit}`, body )
        .then(({ data }) => {
            alertMessage(data)
            
            if (data.title === 'OK') {
                executeFetchAllDeposits()
                onResetForm()
                closeModal()
            
            }
            
        })
        .catch(error => {
            console.log('API ERROR: ', error)
        })
    }

    const handleChangeAmount = (event) => {

        //HOOKS
        const {FormDeposit} = Forms
        const {setFormState, formState, onInputChangeForNumber} = FormDeposit
        const {deposito_tipo_cambio} = formState
        
        const { value } = event.target

        onInputChangeForNumber(event)
        const clean_value = convertToFloat(value)

        //Verificamos si tiene data
        const tipo_cambio = deposito_tipo_cambio !== '' ? parseFloat(deposito_tipo_cambio) : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales : numberFormatter.format(clean_value*tipo_cambio),
                deposito_dolares : numberFormatter.format(clean_value),
                clean_deposito_quetzales: (clean_value*tipo_cambio),
                clean_deposito_dolares: clean_value
            }))
        }else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales : numberFormatter.format(clean_value),
                deposito_dolares : numberFormatter.format(clean_value/tipo_cambio),
                clean_deposito_quetzales: clean_value,
                clean_deposito_dolares: (clean_value/tipo_cambio)
            }))
        }
    }

    const handleChangeExchangeRate = (event) => {

        //HOOKS
        const {FormDeposit} = Forms
        const {setFormState, formState} = FormDeposit
        const {clean_deposito_monto} = formState
        
        const { name, value } = event.target

        //Verificamos si tiene data
        // const monto = deposito_monto !== '' ? deposito_monto : 0;
        const tipo_cambio = value !== '' ? parseFloat(value) : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : numberFormatter.format(clean_deposito_monto*tipo_cambio),
                deposito_dolares : numberFormatter.format(clean_deposito_monto),
                clean_deposito_quetzales: (clean_deposito_monto*tipo_cambio),
                clean_deposito_dolares: clean_deposito_monto
            }))
        }else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : numberFormatter.format(clean_deposito_monto),
                deposito_dolares : (tipo_cambio === 0) ? 0 : numberFormatter.format(clean_deposito_monto/tipo_cambio),
                clean_deposito_quetzales: clean_deposito_monto,
                clean_deposito_dolares: (tipo_cambio === 0) ? 0 : (clean_deposito_monto/tipo_cambio)
            }))
        }else {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value
            }))
        }
    }

    const handleClickFetchInfoDeposit = async (iddeposit) => {
        
        const { FormDeposit: {onResetForm}} = Forms


        const { fetchInfoDeposit: {setParamsToSearch, executeFetchInfoDeposit} } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({iddeposit: iddeposit})
        executeFetchInfoDeposit()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {}, 'READONLY')

    }

    const handleClickDownloadImage = async ( customFileName, openUrl) => {
        
        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();
      
            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);
      
            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();
      
            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);
            
            toast.success('Se ha descargado la imagen');
    
          } catch (error) {
            console.error('Error al descargar la imagen', error);
          }
    
    }

    const handleClickDeleteDeposit = (iddeposit) => {

        const { fetchAllDeposits:{executeFetchAllDeposits} } = FetchData
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/vehicle/mgmt-sales/delete-deposit/${iddeposit}`)
                .then( ({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        executeFetchAllDeposits()
                        }else{
                            
                        }
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const onSubmitFormPreInventory = async (e) => {

        e.preventDefault()

        const {getCurrentDate} = Helpers

        //HOOKS
        const { FormPreInvventory:{formState}, FormRequestGlobal} = Forms
        const formStateGlobal = FormRequestGlobal.formState

        const { modalOpeningMode } = globalStates

        const { fetchAllPreInventory:{executeFetchAllPreInventory} } = FetchData


        let _data = {
            idventa: formStateGlobal.idventa,
            valor: formState.clean_valor,
            marca: formState.marca,
            modelo: formState.modelo,
            linea: formState.linea,
            color: formState.color,
            matricula: formState.matricula,
            chasis: formState.chasis, 
        }


        if(formState.idvehicledeposit>0){

            if (modalOpeningMode==='EDITABLE') {
                
                _data['usuario_modifico'] = user.username; 
                _data['fecha_modifico'] = getCurrentDate();

                await marvarApi.put( `/vehicle/mgmt-sales/pre-inventory/${formState.idvehicledeposit}`, _data )
                    .then(({ data }) => {

                        alertMessage(data)

                        if (data.title === 'OK') {
                            executeFetchAllPreInventory()
                            handleClickCloseModal()
                        }
                    
                    }).catch(error => {console.log('API ERROR: ', error)})
            }else{
                executeFetchAllPreInventory()
                handleClickCloseModal()
            }

        }else{

            _data['usuario_creo'] = user.username; 
            _data['fecha_creo'] = getCurrentDate();

            await marvarApi.post( `/vehicle/mgmt-sales/pre-inventory`, _data )
                .then(({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        executeFetchAllPreInventory()
                        handleClickCloseModal()
                    }
                    
                }).catch(error => {console.log('API ERROR: ', error)})
            }
            
    }


    const handleClickFetchInfoPreInventory = async (idvehicledeposit, modeOpening) => {
        
        const { FormPreInvventory: {onResetForm}} = Forms

        const { fetchInfoPreInventory : {setParamsToSearch, executeFetchPreInventory} } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({idvehicledeposit: idvehicledeposit})
        executeFetchPreInventory()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowModal('', 'Formulario de Pre Inventario', 'preinventory-section', {}, modeOpening)

    }

    const handleClickDeletePreInventory = (idvehicledeposit) => {

        const { fetchAllPreInventory:{executeFetchAllPreInventory} } = FetchData
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/vehicle/mgmt-sales/delete-pre-inventory/${idvehicledeposit}`)
                .then( ({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        executeFetchAllPreInventory()
                        }else{
                            
                        }
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const handleClickFetchInfoSales = async (idventa, modeOpening) => {
        
        const { FormRequestGlobal: {onResetForm, setFormState}} = Forms

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setFormState(prevState => ({
            ...prevState,
            idventa: idventa,
        }))
        
        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowForm(modeOpening)

    }

    const handleClickDeleteVehiclSale = (idventa) => {

        const { fetchAllVehicleSales:{executeFetchAllVehicleSales} } = FetchData
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/vehicle/mgmt-sales/${idventa}`)
                .then( ({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        executeFetchAllVehicleSales()
                        }
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const handleClickApproval = async () => {
        //HOOKS
        const { FormRequestGlobal} = Forms
        const { formState, setFormState } = FormRequestGlobal
        const {getCurrentDate} = Helpers


        if(formState.aprobacion_check === 'Devuelto a Gestor'){
            // await marvarApi.put(`/vehicle/legal/aprobacion-check/${formState.idcredito}`, {aprobacion_check: 'Devuelto a Juridico', aprobacion_usuario: user.username, aprobacion_fecha: getCurrentDate()})
            //     .then(({ data }) => {
            //         alertMessage(data)
            //         handleClickHideForm()
            //     })
            //     .catch(error => {
            //         console.log('API ERROR: ', error)
            //     })
        }else{
            handleClickHideForm()
        }
    }

    const handleClickUpdateAprobacion = async (e) => {

        const {getCurrentDate} = Helpers

        const { FormRequestGlobal:{ formState } } = Forms

        const { fetchAllVehicleSales :{executeFetchAllVehicleSales}} = FetchData

        const body = {
            idvehicle: formState.idvehiculo, 
            aprobacion_check: formState.aprobacion_check, 
            aprobacion_usuario: user.username, 
            aprobacion_fecha: getCurrentDate()
        }

        await marvarApi.put(`/vehicle/admin-sales/aprobacion-check/${formState.idventa}`, body).then(({ data }) => {
            alertMessage(data)
            if (data.title === 'OK') {
                executeFetchAllVehicleSales()
                handleClickHideForm()
            }
        })
        .catch(error => {
            console.log('API ERROR: ', error)
        })
    }

    


    return Object.freeze({
        handleClickShowForm,
        handleClickHideForm,
        onSubmitFormApplies,
        onSendLogs,
        handleClickCleanUpFiles,
        handleClickReturnStep,
        handleClickNextStep,
        onSubmitFormFiles,
        handleClickDeleteDocument,
        handleClickShowModal,
        handleClickCloseModal,
        onSubmitFormDeposits,
        handleChangeTypeCurrency,
        handleChangeAmount,
        handleChangeExchangeRate,
        handleClickFetchInfoSales,
        handleClickFetchInfoDeposit,
        handleClickDownloadImage,
        handleClickDeleteDeposit,
        onSubmitFormPreInventory,
        handleClickFetchInfoPreInventory,
        handleClickDeletePreInventory,
        handleClickDeleteVehiclSale,
        handleClickApproval,
        handleClickUpdateAprobacion,
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message} = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}